import { render, staticRenderFns } from "./CategoryGoods.vue?vue&type=template&id=859ae6dc&"
import script from "./CategoryGoods.vue?vue&type=script&lang=js&"
export * from "./CategoryGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports